<template>
  <div class="main mainPortableX">
    <div
      :class="['test-section', activetab === 5 ? 'test-section-multiple-5' : '', activetab === 6 ? 'test-section-multiple-6' : '']"
    >
      <div
        :class="['wrapPortable', 'Indica', activetab === 3 || activetab === 5 || activetab === 6? 'Indica3' : '']"
      >
        <div>
          <h1 class="indH1">{{ info[activetab-1].title }}</h1>
          <h2 class="indH2">{{ info[activetab-1].underTitle }}</h2>
        </div>
      </div>
      <div id="Tabs" :class="['Container', 'ContainerFold']">
        <div class="Tabs tabTest">
          <!--<a v-for="tab in tabs" :key="tab.name" v-on:click="activetab = tab.name" v-bind:class="[ activetab === tab.name ? 'active' : '' ]">{{tab.name}}</a>-->
          <ul>
            <li
              v-for="tab in tabs"
              :key="tab.name"
              v-bind:class="[ activetab === tab.name ? 'active' : '', activetab > tab.name ? 'passed' : '']"
            >
              <p>{{tab.name}}</p>
            </li>
          </ul>
        </div>

        <div :class="['Content', 'contentTest', activetab === 1 ? 'Content1' : '']">
          <div v-if="activetab === 1" class="tabcontent testTab tabTestFold">
            <Test1 @stopClic="verifAction()"></Test1>
          </div>
          <div v-if="activetab === 2" class="tabcontent testTab tabTestFold">
            <Test2 @choice2="verifAction()"></Test2>
          </div>
          <div v-if="activetab === 3" class="tabcontent testTab tabTestFold">
            <Test3 @choice3="verifAction()"></Test3>
          </div>
          <div v-if="activetab === 4" class="tabcontent testTab tabTestFold">
            <Test4 @choice4="verifAction()"></Test4>
          </div>
          <div v-if="activetab === 5" class="tabcontent testTab testQmultiple">
            <Test5 @choice5="verifAction()"></Test5>
          </div>
          <div v-if="activetab === 6" class="tabcontent testTab testQmultiple testQmultiple6">
            <Test6 @choice6="verifAction()"></Test6>
          </div>
          <div v-if="activetab === 7" class="tabcontent testTab">
            <div class="resultatTest">
              <h1>Felicitation le test est terminé</h1>
              
              <!--
                   <ul id='final_result'>
                     <li v-for="test in tabs" :key="test.name">
                        <p v-if="test.name-1 !== 4">{{info[test.name-1].underTitle}} : {{ testResult['Test'+test.name].resultat }}</p>
                        <p v-if="test.name-1 == 4">IMC : {{ testResult['Test'+test.name].resultat }}</p>
                      </li>
              </ul>-->
              <div class="niveau1">
                <div id="niveau2">
                  <p v-if="this.resultNiveau !== undefined">Niveau : {{this.resultNiveau}}</p>
                </div>
              </div>
              <div class="infoRecap">
                <p>Les différents niveaux sont dans l'ordre croisant : débutant intermédiaire, et confirmé.</p>
              </div>
              <h3>Vous allez être redirigé dans quelques secondes vers les Statistiques</h3>
              <router-link
                to="Accueil"
                class="submitQuestionnaire finVideoBoutton"
                title="retour Accueil"
                v-if="afficheAcc == true"
              >Accueil</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="subTest subTest-portable">
        <div :class="['bouton2-portable','bouton-iphone',  activetab == 4 ? 'bouton4-portable, bouton4-iphone' : '']">
          <button
            class="submitQuestionnaire questionTest submit-portable"
            v-if="activetab == 1 || activetab == 4"
            v-on:click="updateData()"
            :class="[verif === false ? 'inActived' : '', activetab == 4 ? 'portable44' : '']"
          >Valider le test</button>
        </div>
        <button
          class="submitQuestionnaire questionTest submit-responsive"
          v-if="activetab == 1 || activetab == 4"
          v-on:click="updateData()"
          :class="[verif === false ? 'inActived' : '']"
        >Valider le test</button>
        <!--<button class="submitQuestionnaire" v-if="activetab == 7" v-on:click="postData()" required>Envoyer les Résultats</button>-->
      </div>
    </div>
  </div>
</template>

<script>
import Test1 from "@/components/Test/Test_1";
import Test2 from "@/components/Test/Test_2";
import Test3 from "@/components/Test/Test_3";
import Test4 from "@/components/Test/Test_4";
import Test5 from "@/components/Test/Test_5";
import Test6 from "@/components/Test/Test_6";
import { User } from "../controller/user.js";
import { hostUrl } from "../_helpers/global_var";
import { Analyse } from "../controller/analyseResultat.js";

const axios = require("axios").default;

export default {
  name: "Test",
  components: {
    Test1: Test1,
    Test2: Test2,
    Test3: Test3,
    Test4: Test4,
    Test5: Test5,
    Test6: Test6,
  },
  data() {
    return {
      activetab: 1,
      tabs: [
        { name: 1 },
        { name: 2 },
        { name: 3 },
        { name: 4 },
        { name: 5 },
        { name: 6 },
      ],
      info: [
        { title: "Votre condition physique", underTitle: "Test d'équilibre" },
        {
          title: "Votre condition physique",
          underTitle: "Test de souplesse du tronc",
        },
        {
          title: "Votre condition physique",
          underTitle: "Test de souplesse des épaules",
        },
        { title: "Votre condition physique", underTitle: "Test assis debout" },
        {
          title: "Votre condition physique",
          underTitle: "Score d'activité physique de Dijon",
        },
        {
          title: "Votre condition physique",
          underTitle: "Score d'activité physique de Dijon",
        },
        { title: "Votre Resultat", underTitle: "Resultats" },
      ],
      testResult: [],
      user: JSON.parse(localStorage.user) || [],
      verif: false,
      resultNiveau: undefined,
      afficheAcc: false,
    };
  },
  created() {
    if (typeof localStorage.user !== undefined) {
      this.user = JSON.parse(localStorage.user);
      if (this.user.liste_Metier !== [] && this.user.liste_Metier.length > 0) {
        this.tableau_profession = this.user.liste_Metier;
        console.log(this.user.liste_Metier.length);
      }
      //console.log(this.user);
    } else {
      console.log("var not exist");
    }
  },
  methods: {
    defineTest(index) {
      let balise = "<" + index + "></" + index + ">";
      return balise;
    },
    even(numbers, activetab) {
      return numbers.filter(function (number) {
        return number === activetab;
      });
    },
    updateData(data = null) {
      if (this.verif == true) {
        //-----------------test 1------------------
        if (this.testResult["Test1"] == null) {
          let nb = localStorage.resultatTest1;
          this.testResult["Test1"] = { resultat: nb };
          console.log(this.testResult);
          //-----------------test 2------------------
        } else if (this.testResult["Test2"] == null && data !== null) {
          this.testResult["Test2"] = { resultat: data };
          localStorage.removeItem("vive");
          setTimeout(() => {
            this.majActivtab();
          }, 1000);
          //console.log(this.testResult, active, activeId);
          //-----------------test 3------------------
        } else if (this.testResult["Test3"] == null) {
          this.testResult["Test3"] = { resultat: data };
          localStorage.removeItem("vive");
          setTimeout(() => {
            this.majActivtab();
          }, 1000);
          //console.log(this.testResult);
          //-----------------test 4------------------
        } else if (this.testResult["Test4"] == null) {
          let input = document.getElementById("nb_leves");
          let nbLeves = Number(input.value);
          console.log(nbLeves);
          if (isNaN(nbLeves) === false) {
            this.testResult["Test4"] = { resultat: nbLeves };
          } else {
            nbLeves = 0;
            this.testResult["Test4"] = { resultat: nbLeves };
          }
          //console.log(this.testResult);
          //-----------------test 5------------------
        } else if (this.testResult["Test5"] == null) {
          let resultat5 = localStorage.vive;
          this.testResult["Test5"] = resultat5;
          console.log(resultat5);
          localStorage.removeItem("vive");
          //console.log(this.testResult);
          //-----------------test 6------------------
        } else if (this.testResult["Test6"] == null) {
          let test5 = this.testResult["Test5"];
          /*
        let habitude = Number(document.getElementById('habitude').getAttribute('data-value'));
        let moyenne = Number(document.getElementById('moyenne').getAttribute('data-value'));
        let activite_tmp = Number(document.getElementById('activite_tmp').getAttribute('data-value'));
        let activite_sportive = Number(document.getElementById('activite_sportive').getAttribute('data-value'));
        let repos = Number(document.getElementById('repos').getAttribute('data-value'));*/

          let resultat6 = localStorage.vive;

          this.testResult["Test6"] = { resultat: resultat6 };
          this.testResult["Test5"] = { resultat: this.calcImc() };
          localStorage.removeItem("vive");
          // console.log(this.testResult);
        }

        if (this.activetab !== 2 && this.activetab !== 3) {
          console.log(this.activetab);
          this.majActivtab();
        }

        if (this.activetab > 0 && this.activetab <= 6) {
          this.verif = false;
        }
      } else {
        alert(
          "Veuillez faire l'exercice en cour avant de valider et de pouvoir passer au suivant."
        );
      }
    },
    majActivtab() {
      if (this.activetab >= 1 && this.activetab < 6) {
        this.activetab++;
      } else if (this.activetab == 6) {
        this.activetab = 7;
        console.log("ok12");
        this.progress();
      }
    },
    calcImc() {
      var imc = this.user.poids / Math.pow(this.user.taille / 100, 2);
      imc = Number(imc);
      return Number.parseFloat(imc).toFixed(1);
    },
    async postData() {
      let json = JSON.stringify([
        { test: "testEquilibre", resultat: this.testResult["Test1"].resultat },
        {
          test: "testSouplesseTronc",
          resultat: this.testResult["Test2"].resultat,
        },
        {
          test: "testSouplesseEpaules",
          resultat: this.testResult["Test3"].resultat,
        },
        {
          test: "testAssisDebout",
          resultat: this.testResult["Test4"].resultat,
        },
        { test: "imc", resultat: this.testResult["Test5"].resultat },
        { test: "testDijon", resultat: this.testResult["Test6"].resultat },
        { test: "niveau", resultat: this.niveauChiffre },
      ]);

      //console.log(this.testResult, json);

      await axios

        .post(hostUrl + "/salarie/editResultat/" + this.user.salarie_id, json)
        .then((response) => (localStorage.resultats = response.data))
        .then((localStorage.refaireTest = false))
        .catch((error) => console.log(error));

      if (localStorage.refaireDoudou == true) {
        this.$router.push({ name: "Indicateur" });
      } else {
        this.$router.push({ name: "Statistiques" });
      }

      this.afficheAcc = true;
    },
    reverif() {
      if (this.activetab === 1) {
        //console.log(true, document.getElementsByClassName('stopClic'));
        return (this.verif = false);
      }
    },
    verifAction() {
      if (this.activetab === 1 && this.verif == false) {
        //console.log(true, document.getElementsByClassName('stopClic'));
        return (this.verif = true);
      } else if (this.activetab === 2 && this.verif == false) {
        //console.log(true);
        this.verif = true;
        //console.log(localStorage.vive);
        return this.updateData(localStorage.vive);
      } else if (this.activetab === 3 && this.verif == false) {
        this.verif = true;
        //console.log(localStorage.vive);
        return this.updateData(localStorage.vive);
      } else if (this.activetab === 4 && this.verif == false) {
        //console.log(true);
        return (this.verif = true);
      } else if (this.activetab === 5 && this.verif == false) {
        this.verif = true;
        //console.log(localStorage.vive);
        return this.updateData(localStorage.vive);
      } else if (this.activetab === 6 && this.verif == false) {
        this.verif = true;
        // console.log(localStorage.vive);
        return this.updateData(localStorage.vive);
      }
    },
    progress() {
      if (this.activetab == 7) {
        console.log("ok");
        let array = {
          testEquilibre: this.testResult["Test1"].resultat,
          testSouplesseTronc: this.testResult["Test2"].resultat,
          testSouplesseEpaules: this.testResult["Test3"].resultat,
          testAssisDebout: this.testResult["Test4"].resultat,
          imc: this.testResult["Test5"].resultat,
          testDijon: this.testResult["Test6"].resultat,
        };
        console.log(array);
        var result = new Analyse(array);
        var niveau = result.niveau;
        this.niveauChiffre = result.niveauChiffre;
        result = result.resultatFinal;

        console.log(result);

        var pourcent = Math.round((result * 100) / 120);
        console.log(pourcent, this.resultNiveau);
        setTimeout(() => {
          this.resultNiveau = niveau.toUpperCase();
          document.getElementById("niveau2").style.width = pourcent + "%";
          console.log(pourcent + "%");
          document.getElementById("niveau2").classList.add("remplissage");
        }, 1000);

        setTimeout(() => {
          this.postData();
        }, 5000);
      }
    },
  },

  beforeRouteLeave: (to, from, next) => {
    console.log(localStorage.resultats);
    if (
      typeof localStorage.resultats !== "undefined" &&
      localStorage.Test !== "[]"
    ) {
      if (
        localStorage.refaireTest !== undefined &&
        localStorage.refaireTest == true
      ) {
        alert(
          "Il est impératif qui vous ayez réalisé ce questionnaire, vous pourrez accéder aux autres pages une fois qu'il sera validé"
        );
        next(false);
      }
      next();
    } else {
      alert(
        "Il est impératif qui vous ayez réalisé ce test, vous pourrez accéder aux autres pages une fois qu'il sera validé"
      );
      next(false);
    }
  },
};
</script>
<style>
.inActived {
  background-color: #9d9d9c;
  display: none;
}
.niveau1 {
  width: 80%;
  height: 50px;
  margin-left: auto;
  margin-right: auto;
  background: transparent;
  border: 2px solid #473334;
  border-radius: 15px;
}
#niveau2 {
  /*background: transparent;*/
  height: 100%;
  transition: background-color 1s ease-out;
  border-radius: 15px;
}
#niveau2 p {
  margin-top: 0;
  height: 100%;
  margin-bottom: 0;
  text-align: start;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #473334;
}
.remplissage {
  background-color: #54c7da !important;
  transition: background-color 1.5s linear !important;
}
.infoRecap {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  color: #473334;
}
.labelPerso {
  overflow: visible;
} /*
.mainPortableX{
  overflow-y: auto;
  overflow-x: hidden;
}*/
</style>


// WEBPACK FOOTER //
// src/components/Test.vue